import { PaletteOptions } from '@mui/material';

import { tokens } from './tokens';

const c = tokens.color;

export const palette: PaletteOptions = {
    mode: 'light',
    common: { black: c.ink, white: c.surface },
    primary: { main: c.accent, dark: c.accentHi, light: c.accentSoft, contrastText: c.inkInvert },
    // Everything that asks for the secondary colour here is destructive or a
    // warning flag — a delete button, a decline, the marker beside a supplier
    // who charges. The old theme gave it a crimson; without a value of its own
    // the redesign fell back to the library's purple.
    secondary: { main: c.crit, dark: c.crit, light: c.critSoft, contrastText: c.inkInvert },
    error: { main: c.crit, light: c.critSoft, contrastText: c.inkInvert },
    warning: { main: c.warn, light: c.warnSoft, contrastText: c.inkInvert },
    success: { main: c.ok, light: c.okSoft, contrastText: c.inkInvert },
    // info shares the accent hue — status chips never use the solid fill (see components.ts)
    info: { main: c.accent, dark: c.accentHi, light: c.accentSoft, contrastText: c.inkInvert },
    text: { primary: c.ink, secondary: c.ink2, disabled: c.ink3 },
    background: { default: c.canvas, paper: c.surface },
    divider: c.line,
    grey: {
        100: c.lineSoft,
        200: c.neutralSoft,
        300: c.line,
        400: c.lineHard,
        500: c.ink3,
        700: c.neutral,
        800: c.ink2,
        900: c.ink,
    },
};
